import React from "react";

import { StyledGrid, WidgetTitle } from "components/simple";
import { spacingDefaults } from "style/constants";
import UpcomingSessionCard, { UpcomingSession } from "./UpcomingSessionCard";
import {
  CoachingSession,
  ImagingSession,
  SessionType
} from "components/pages/Dashboard/CycleSummary/types";
import { IGroupSession } from "components/pages/Dashboard/CycleSummary/GroupCoachingSession";

interface UpcomingSessionsProps {
  groupSessionList: IGroupSession[];
  imagingSessionList: ImagingSession[];
  coachingSessionList: CoachingSession[];
}

const UpcomingSessions: React.FC<UpcomingSessionsProps> = ({
  groupSessionList,
  imagingSessionList,
  coachingSessionList
}: UpcomingSessionsProps) => {
  const allUpcomingSessions: UpcomingSession[] = [];

  groupSessionList?.map(gs => {
    const upcoming: UpcomingSession = {
      id: gs.id,
      title: gs.title,
      sessionTime: gs.sessionTime,
      status: gs.status,
      type: SessionType.GROUP,
      groupCoachingJoinLink: gs.groupCoachingJoinLink
    };
    allUpcomingSessions.push(upcoming);
  });

  imagingSessionList?.map(is => {
    const upcoming: UpcomingSession = {
      id: is.id,
      sessionTime: is.sessionTime,
      status: is.status,
      type: SessionType.IMAGING,
      acuityConfirmationNumber: is.acuityConfirmationNumber
    };
    allUpcomingSessions.push(upcoming);
  });

  coachingSessionList?.map(cs => {
    const upcoming: UpcomingSession = {
      id: cs.id,
      sessionTime: cs.sessionTime,
      status: cs.status,
      type: SessionType.COACHING,
      acuityConfirmationNumber: cs.acuityConfirmationNumber
    };
    allUpcomingSessions.push(upcoming);
  });

  allUpcomingSessions.sort(
    (a, b) =>
      new Date(a.sessionTime).getTime() - new Date(b.sessionTime).getTime()
  );

  return (
    <>
      <StyledGrid item xs={12} margin={`${spacingDefaults.normal} 0`}>
        <WidgetTitle id="upcoming-sessions">Upcoming Sessions</WidgetTitle>
      </StyledGrid>
      <UpcomingSessionCard upcomingSessions={allUpcomingSessions} />
    </>
  );
};

export default UpcomingSessions;
